import React from 'react';
import { Carousel, Col } from 'react-bootstrap';
import ExternalImage from './ExternalImage';
import './ProductCarousel.css';

const ProductCarousel = ({
  media, activeIndex, onSelect, mediaName,
}) => {
  if (!media || !media.length) return null;

  return (
    <Col>
      <Carousel
        className='product-carousel'
        onSelect={nextIndex => onSelect(nextIndex)}
        activeIndex={activeIndex}
        interval={null}
      >
        {media.map((mediaItem, index) => (
          <Carousel.Item key={`media-item-${mediaItem.url}`}>
            {index === activeIndex ? (
              <ExternalImage
                src={mediaItem.url}
                key={mediaItem.url}
                width={550}
                height={550}
                alt={
                  mediaItem.altTag !== 'NONE'
                    ? mediaItem.altTag
                    : `${mediaName} example ${index + 1}`
                }
                title={mediaName}
              />
            ) : (
              <div className='productImagePlaceholder' />
            )}
          </Carousel.Item>
        ))}
      </Carousel>
    </Col>
  );
};

export default ProductCarousel;
